(function () {
  async function fetchEbayComps(card) {
    try {
      if (!window.GCA_EBAY_ENDPOINT) {
        return { comps: [], confidence: 0 };
      }

      const res = await fetch(
        `${window.GCA_EBAY_ENDPOINT}?q=${encodeURIComponent(
          `${card.player} ${card.year} ${card.product} ${card.grade || ""}`
        )}`
      );

      const data = await res.json();

      if (!Array.isArray(data.comps)) {
        return { comps: [], confidence: 0 };
      }

      return {
        comps: data.comps,
        confidence: Math.min(data.comps.length / 5, 1)
      };
    } catch (err) {
      console.warn("eBay fetch failed:", err);
      return { comps: [], confidence: 0 };
    }
  }

  function getAIFallback(card) {
  if (!window.GCAValueEngine?.estimateCard) {
    return { value: 0, source: "ai", confidence: 0 };
  }

  const estimate = window.GCAValueEngine.estimateCard(card) || {};

  return {
    value: Number(
      estimate.estimatedValue ??
      estimate.value ??
      0
    ),
    source: "ai",
    confidence: 0.4
  };
}

  async function getMarketEstimate(card) {
    const ebay = await fetchEbayComps(card);

    if (ebay.confidence >= 0.6 && ebay.comps.length) {
      const avg =
        ebay.comps.reduce((sum, c) => sum + Number(c.price || 0), 0) /
        ebay.comps.length;

      return {
        value: Math.round(avg),
        source: "ebay",
        confidence: ebay.confidence,
        comps: ebay.comps
      };
    }

    return getAIFallback(card);
  }

  window.GCAMarketEngine = {
    getMarketEstimate
  };

  console.log("🧠 GCA Market Engine loaded");
})();
